import { useState, useEffect } from 'react'
import debounce from 'lodash/debounce'

function getWindowHeight () {
  const { innerHeight: height } = window

  return {
    height
  }
}

function useWindowHeight () {
  const [windowHeight, setWindowHeight] = useState(getWindowHeight())

  useEffect(() => {
    function handleResize () {
      setWindowHeight(getWindowHeight())
    }

    window.addEventListener('resize', debounce(handleResize, 300))
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowHeight
}

export default function SetViewportHeight () {
  const { height } = useWindowHeight()
  const vh = height * 0.01

  document.documentElement.style.setProperty('--vh', `${vh}px`)

  return null
}
